import * as priceFragments from '@/services/price/fragments';

export default `
mutation update_component(
  $component: [component_insert_input!]!
  $delete_vendor_ids: [uuid!]!
  ${priceFragments.mutationArgs}
) {
  ${priceFragments.mutations}

  insert_component(
    objects: $component,
    on_conflict: {
      constraint: component_pkey,
      update_columns: [
        name
        notes
        properties
      ]
    }
  ) {
    affected_rows
    returning {
      id
    }
  }

  delete_vendor_component(
    where: {
      id: {
        _in: $delete_vendor_ids
      }
    }
  ) {
    affected_rows
    returning {
      id
    }
  }
}
`;
